module.exports = __webpack_public_path__ + "img/stakebodyatten_parked.ecf5db51.svg";